export const SESSION_ID_LS_KEY = 'sessionId';
export const AUTHORIZATION_LS_KEY = 'authorization_token';
export const SIGNUP_STEP_LS_KEY = 'signup_step';
export const SIGNUP_EMAIL_LS_KEY = 'signup_email';
